import * as colors from './colors'

const styles = {
    contextBarItemCtr: {},
    contextBarItem: {
        '&:hover': {
            backgroundColor: 'white',
            color: colors.secondaryOne,
            fontWeight: 'bold',
        },
        backgroundColor: colors.gray,
        color: 'inherit',
        cursor: 'pointer',
        display: 'block',
        fontSize: '20px',
        padding: '10px',
        textAlign: 'center',
        textDecoration: 'none',
    },
    disabled: {
        opacity: 0.3,
    },
}

const extendedStyles = {
    ...styles,
    contextBarItemActive: {
        ...styles.contextBarItem,
        backgroundColor: colors.white,
        color: colors.secondaryOne,
        fontWeight: 'bold',
    },
}

export default extendedStyles
